import { NavLink, useNavigate, useLocation } from "react-router-dom";
import { useState, useEffect } from "react";
import {
  FaHome,
  FaInfoCircle,
  FaFileAlt,
  FaUsers,
  FaQuestionCircle,
  FaSignOutAlt,
  FaHistory,
  FaMapMarkerAlt,
  FaBars,
  FaTimes
} from "react-icons/fa";
import "../styles/SidebarPaciente.css";
import logo from "../images/logo login.svg";

const SidebarPaciente = () => {
  const [collapsed, setCollapsed] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  const navigate = useNavigate();
  const location = useLocation();

  // Detecta mudança de tamanho da tela
  useEffect(() => {
    const handleResize = () => {
      const mobile = window.innerWidth <= 768;
      setIsMobile(mobile);
      if (mobile) {
        setCollapsed(true);
      }
    };

    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  // Aplica estado inicial ao montar
  useEffect(() => {
    const mobile = window.innerWidth <= 768;
    setIsMobile(mobile);
    if (mobile) {
      setCollapsed(true);
    }
  }, []);

  // Fecha sidebar no mobile ao trocar de rota
  useEffect(() => {
    if (isMobile) {
      setCollapsed(true);
    }
  }, [location.pathname, isMobile]);

  const toggleSidebar = () => {
    setCollapsed(!collapsed);
    console.log("Collapsed agora:", !collapsed);
  };

  const handleLogout = () => {
    localStorage.clear();
    navigate("/");
  };

  return (
    <>
      {isMobile && (
        <button 
          className="menu-toggle" 
          onClick={toggleSidebar}
          aria-label="Toggle menu"
        >
          {collapsed ? <FaBars /> : <FaTimes />}
        </button>
      )}
      
      <nav 
        className={`sidebar-paciente ${collapsed ? "collapsed" : ""} ${isMobile && !collapsed ? "expanded" : ""}`} 
        id="sidebar-paciente"
      >
        <div className="sidebar-paciente-header">
          {!collapsed && <img src={logo} alt="Logo Cronus" />}
          {!isMobile && (
            <button id="toggle-btn-paciente" onClick={toggleSidebar} aria-label="Toggle sidebar">
              &#9776;
            </button>
          )}
        </div>

        <ul className="list-unstyled-paciente components">
          <li>
            <NavLink to="/dashpacientes" className={({ isActive }) => (isActive ? "active" : "")}>
              <FaHome className="icon-paciente" />
              {!collapsed && <span className="nav-text">Início</span>}
            </NavLink>
          </li>
          <li>
            <NavLink to="/infopaciente" className={({ isActive }) => (isActive ? "active" : "")}>
              <FaInfoCircle className="icon-paciente" />
              {!collapsed && <span className="nav-text">Suas informações</span>}
            </NavLink>
          </li>
          <li>
            <NavLink to="/historicopaciente" className={({ isActive }) => (isActive ? "active" : "")}>
              <FaHistory className="icon-paciente" />
              {!collapsed && <span className="nav-text">Histórico</span>}
            </NavLink>
          </li>
          <li>
            <NavLink to="/servicospaciente" className={({ isActive }) => (isActive ? "active" : "")}>
              <FaMapMarkerAlt className="icon-paciente" />
              {!collapsed && <span className="nav-text">Serviços da sua região</span>}
            </NavLink>
          </li>
          <li>
            <NavLink to="/socialpaciente" className={({ isActive }) => (isActive ? "active" : "")}>
              <FaUsers className="icon-paciente" />
              {!collapsed && <span className="nav-text">Social</span>}
            </NavLink>
          </li>
          <li>
            <NavLink to="/aboutpaciente" className={({ isActive }) => (isActive ? "active" : "")}>
              <FaQuestionCircle className="icon-paciente" />
              {!collapsed && <span className="nav-text">Sobre</span>}
            </NavLink>
          </li>
        </ul>

        <div className="logout-paciente">
          <button onClick={handleLogout}>
            <FaSignOutAlt className="icon-paciente" />
            {!collapsed && <span className="nav-text">Sair</span>}
          </button>
        </div>
      </nav>
      
      {isMobile && !collapsed && (
        <div className="sidebar-overlay" onClick={toggleSidebar}></div>
      )}
    </>
  );
};

export default SidebarPaciente;
